export default __webpack_public_path__ + "static/media/tab-profile-inact.8bac2dc9.svg";